import * as React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from 'helpers/theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';

const useStyles = createUseStyles((theme: Theme) => ({
  checkItem: {
    display: 'flex',
    gap: '20px',
    alignItems: 'center'
  },
  checkItemIcon: {
    width: 25,
    height: '100%'
  },
  checkItemText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  checkItemName: {
    fontSize: 13,
    fontWeight: 700
  },
  checkItemSize: {
    fontSize: 12,
    fontWeight: 300
  }
}));

type Props = {
  errors: string[];
  name: string;
};

function ErrorItem(props: Props) {
  const classes = useStyles();
  return (
    <div className={classes.checkItem}>
      <FontAwesomeIcon
        icon={props.errors.length == 0 ? faCircleCheck : faCircleXmark}
        className={classes.checkItemIcon}
        color={props.errors.length == 0 ? '#17BC25' : '#EC3737'}
      />
      <div className={classes.checkItemText}>
        <div className={classes.checkItemName}>{props.name}</div>
        <div className={classes.checkItemSize}>
          {props.errors.length == 0 && 'No issues found'}
          {props.errors.map((err) => (
            <>
              {err} <br />
            </>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ErrorItem;
